module.exports = __webpack_public_path__ + "img/icon-withdraw.f4bd0826.png";